var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _rect6, _rect7, _rect8, _rect9, _circle4, _circle5, _circle6, _rect10, _rect11, _rect12, _rect13, _circle7, _circle8, _circle9, _rect14, _rect15, _rect16, _rect17, _circle10, _circle11, _circle12, _rect18, _rect19, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _g2, _g3, _g4, _g5, _g6, _path19, _rect20, _path20, _circle13, _circle14, _circle15, _rect21, _rect22, _rect23, _rect24, _rect25, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon, _rect26, _path28, _circle16, _circle17, _circle18, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _ellipse, _path37, _path38, _ellipse2, _path39, _path40, _rect40, _path41, _path42, _path43, _path44, _rect41, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _rect42, _path55, _path56, _path57, _path58, _path59, _path60, _rect43, _polygon2, _rect44, _polygon3, _polygon4, _polygon5, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _rect45, _circle19, _circle20, _circle21, _rect46, _rect47, _rect48, _ellipse3, _path74, _path75, _path76, _path77, _path78, _rect49, _polygon6, _polygon7, _path79, _path80, _path81, _path82, _path83, _path84, _rect50, _circle22, _path85, _rect51, _rect52, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _polygon8, _polygon9, _rect53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,650.35a16.32,16.32,0,0,1-10.85-4.2c-19-16.27-19.37-73.9-19.38-76.35-1.67-40.65,5.17-56.67,11.19-62.95,3.5-3.65,6.47-3.69,6.6-3.69v1s-2.73.07-5.94,3.45c-5.86,6.18-12.5,22-10.85,62.17,0,.61.42,59.64,19,75.61a15.26,15.26,0,0,0,12.68,3.77l.15,1A16.91,16.91,0,0,1,90,650.35Z",
    fill: "#344854"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.55,650.16c-22.21,0-26.27-42.51-26.43-44.31-2.59-38.3,2.81-52.69,7.79-58,2.47-2.63,4.55-2.66,4.64-2.66v1s-1.81.06-4,2.43c-3.93,4.3-10.13,17.43-7.44,57.18,0,.42,4.13,43.39,25.43,43.39Z",
    fill: "#344854"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77,648.17c-5.23,0-9.38-1.89-12.36-5.62-11.66-14.63-1.77-52.42-1.35-54l1,.26c-.1.38-10.18,38.9,1.17,53.14,2.91,3.66,7.07,5.43,12.33,5.23l0,1Z",
    fill: "#344854"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.26,
    y: 494.8,
    width: 130,
    height: 158,
    fill: "#344854"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.26,
    y: 605.8,
    width: 152,
    height: 35,
    rx: 5.93,
    fill: "#ccebd4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 615.8,
    width: 162,
    height: 14,
    fill: "#ccebd4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 615.8,
    width: 162,
    height: 14,
    fill: "#fff",
    opacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 140.26,
    y: 619.3,
    width: 93,
    height: 7,
    rx: 3.5,
    fill: "#fff",
    opacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.76,
    cy: 622.8,
    r: 4.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.76,
    cy: 622.8,
    r: 4.5,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.76,
    cy: 622.8,
    r: 4.5,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81.26,
    y: 566.8,
    width: 152,
    height: 35,
    rx: 5.93,
    fill: "#ccebd4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 576.8,
    width: 162,
    height: 14,
    fill: "#ccebd4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 576.8,
    width: 162,
    height: 14,
    fill: "#fff",
    opacity: 0.35
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140.26,
    y: 580.3,
    width: 93,
    height: 7,
    rx: 3.5,
    fill: "#fff",
    opacity: 0.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.76,
    cy: 583.8,
    r: 4.5,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.76,
    cy: 583.8,
    r: 4.5,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.76,
    cy: 583.8,
    r: 4.5,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80.26,
    y: 528.8,
    width: 152,
    height: 35,
    rx: 5.93,
    fill: "#ccebd4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 75.26,
    y: 538.8,
    width: 162,
    height: 14,
    fill: "#ccebd4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 75.26,
    y: 538.8,
    width: 162,
    height: 14,
    fill: "#fff",
    opacity: 0.35
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 139.26,
    y: 542.3,
    width: 93,
    height: 7,
    rx: 3.5,
    fill: "#fff",
    opacity: 0.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.76,
    cy: 545.8,
    r: 4.5,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.76,
    cy: 545.8,
    r: 4.5,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.76,
    cy: 545.8,
    r: 4.5,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 81.26,
    y: 488.8,
    width: 152,
    height: 35,
    rx: 5.93,
    fill: "#ccebd4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 498.8,
    width: 162,
    height: 14,
    fill: "#ccebd4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 498.8,
    width: 162,
    height: 14,
    fill: "#fff",
    opacity: 0.35
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 140.26,
    y: 502.3,
    width: 93,
    height: 7,
    rx: 3.5,
    fill: "#fff",
    opacity: 0.35
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.76,
    cy: 505.8,
    r: 4.5,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.76,
    cy: 505.8,
    r: 4.5,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.76,
    cy: 505.8,
    r: 4.5,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 263.26,
    y: 18.3,
    width: 442.5,
    height: 295,
    rx: 27.62,
    fill: "#344854"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 271.26,
    y: 25.3,
    width: 428,
    height: 278.5,
    rx: 27.62,
    fill: "#ccebd4",
    opacity: 0.28
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M377.24,156.47c-22.2-.32-40.06-8.1-53.09-23.12-32.94-38-24.08-110.59-24-111.32l2,.25c-.09.72-8.83,72.46,23.53,109.76,12.63,14.57,30,22.12,51.6,22.43Z",
    fill: "#344854"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M595.89,157.17l-1-1.74c41.1-22.92,32-129,31.92-130l2-.18a348.2,348.2,0,0,1-.41,56.87C624.62,122,613.68,147.26,595.89,157.17Z",
    fill: "#344854"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M607.75,189.35a97,97,0,0,1-9.76-.41l.23-2c.66.08,66.69,7,106-42.42l1.57,1.25c-20.94,26.3-49.15,36.63-69.12,40.67A148.25,148.25,0,0,1,607.75,189.35Z",
    fill: "#344854"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M599.26,203.8s-2,20-26,23c0,0-9.85,29.55-47.14,26.08h0l-.84-.08s-24.84-2.46-40.75-20.82a49.79,49.79,0,0,1-3.91-5.13l-25.34,0s-10.67,0-20-11.39a45,45,0,0,1-5-7.61H384.31a24.42,24.42,0,0,1-12-3c-5.83-3.29-12.14-10.08-11-24a26.75,26.75,0,0,1,16-19s-11.13-26.33,18.44-33.66c0,0-6.44-24.34,14.56-32.34,0,0,12-6,25,6,0,0,1-21,19-24,0,0,19-4,26,15,0,0,10-21,31-14,0,0,13,2,15,22,0,0,17-16,34,1,0,0,12,12,3,29,0,0,26-8,32,16a25,25,0,0,1-11,26,36.73,36.73,0,0,1,10.88,9.95h0A24.72,24.72,0,0,1,599.26,203.8Z",
    fill: "#f9b499",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.26,161.8a18.57,18.57,0,0,1,6.92-.91,21.53,21.53,0,0,1,6.92,1.51,25,25,0,0,1,3.19,1.6,20,20,0,0,1,2.81,2.19,18,18,0,0,1,4.16,5.61,42.81,42.81,0,0,0-5.14-4.4,25.24,25.24,0,0,0-5.77-3.14,31,31,0,0,0-6.34-1.82A45,45,0,0,0,377.26,161.8Z",
    fill: "#f7a48b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M440.83,124.7a19.65,19.65,0,0,1,8.48,1c.68.26,1.37.5,2,.8l2,1c.61.39,1.21.82,1.82,1.23s1.12.94,1.68,1.41a20.36,20.36,0,0,1,4.95,7.14l.44,1c.12.34.21.69.31,1l.57,2.07a35.91,35.91,0,0,1,.52,4.23c-.55-1.32-.93-2.66-1.46-3.94l-.85-1.89c-.15-.31-.27-.63-.42-.93l-.51-.89-1-1.76-1.19-1.63a12,12,0,0,0-1.29-1.54,11.21,11.21,0,0,0-1.41-1.43,23.76,23.76,0,0,0-6.69-4.45A32.6,32.6,0,0,0,440.83,124.7Z",
    fill: "#f29681"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M475.26,142.8s-7.5,17,9.25,27",
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.38,188s39.88,17.84,56.88,2.84c0,0,28.35-21.21,13.67-39.6a36.78,36.78,0,0,1,14.2,21.41s-19.87,7.19-15.87,35.19H384.31S364.49,209.13,361.38,188Z",
    fill: "#f7a48b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M418.26,137.8s26-4,17-36c0,0,16,14.16.49,30.58C435.75,132.38,430.26,138.8,418.26,137.8Z",
    fill: "#f7a48b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M473.26,112.8s-5,15.21,0,25.11c0,0-15,10.89,0,31.89h17.51s-15.66-17.79-5.08-31.89C485.67,137.91,472.26,132.8,473.26,112.8Z",
    fill: "#f7a48b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M502.26,114.8s40-7,19,35c0,0,10.47,3.49,16.43,11a13.49,13.49,0,0,1-5.87,20.9c-6.24,2.41-16.3,4.66-32.18,4.79a28.06,28.06,0,0,1-20.22-8c-.26-.26-.52-.53-.76-.8,0,0,10.18,14.33.39,33.21,0,0,5.63-2.3,6.92-15.71,0,0,.29-3.41,5.79-2.41l41.26-.09s21-1.91,22.11-22.91c0,0,1.66-19.42-23.1-24.21,0,0,15.29-27.43-10.74-35.11C521.29,110.48,514.26,108.8,502.26,114.8Z",
    fill: "#f7a48b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M558.05,99.77s8.21,26-5.79,37c0,0,18.54-1.38,13.27-25.69C565.53,111.11,563.84,103.75,558.05,99.77Z",
    fill: "#f7a48b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M574.26,175.8s24.17-16.31,14.58-40.66c0,0,12,10.37,4.7,27C593.54,162.16,589.26,173.8,574.26,175.8Z",
    fill: "#f7a48b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M599.26,203.8s-2,20-26,23c0,0-9.85,29.55-47.14,26.08,34.81-3.94,37.14-34.08,37.14-34.08,39.64,6.94,32-35.28,31.88-36A24.72,24.72,0,0,1,599.26,203.8Z",
    fill: "#f7a48b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M543.26,204.8a34.89,34.89,0,0,1,1-10.21,39.61,39.61,0,0,1,3.78-9.63c.45-.75.84-1.52,1.34-2.23l1.51-2.13c.52-.7,1.13-1.32,1.7-2l.86-1,1-.87c.65-.57,1.28-1.17,1.95-1.71l2.13-1.48c.37-.23.71-.49,1.09-.69l1.15-.59c.77-.38,1.54-.75,2.31-1.1-.67.54-1.34,1.06-2,1.57l-1,.75c-.33.26-.62.57-.94.85l-1.86,1.67-1.7,1.82a41.48,41.48,0,0,0-5.75,8.06,54.45,54.45,0,0,0-4,9.1A72.19,72.19,0,0,0,543.26,204.8Z",
    fill: "#f29681"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.26,208.82a1,1,0,0,1-1-.73c-.06-.2-5.36-19.92,11.33-28.68a1,1,0,0,1,1.35.42,1,1,0,0,1-.42,1.35c-15.25,8-10.54,25.62-10.34,26.37a1,1,0,0,1-.69,1.23A1.26,1.26,0,0,1,552.26,208.82Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.81,211.92a1,1,0,0,1-.92-.61c-.2-.49-5-12.06-.11-21.75,2.72-5.43,7.92-9.14,15.45-11a1,1,0,0,1,1.21.72,1,1,0,0,1-.73,1.22c-6.93,1.73-11.68,5.08-14.13,10-4.45,8.86.11,20,.16,20.08a1,1,0,0,1-.54,1.31A.91.91,0,0,1,438.81,211.92Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.66,181.29a1,1,0,0,1-.28,0,1,1,0,0,1-.68-1.24c.05-.16,5-16.59,20.21-14.35a1,1,0,0,1-.3,2c-13.44-2-17.81,12.32-18,12.93A1,1,0,0,1,368.66,181.29Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.2,160.1a1,1,0,0,1-1-.72C378,141,393.69,134.29,393.85,134.22a1,1,0,1,1,.77,1.85c-.58.24-14.2,6.15-9.46,22.76a1,1,0,0,1-.68,1.23A1,1,0,0,1,384.2,160.1Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.26,129.81a1,1,0,0,1-1-.72c-2.51-8.6-2.2-15.82.92-21.46a19.07,19.07,0,0,1,10.54-8.82,1,1,0,1,1,.55,1.92,17.4,17.4,0,0,0-9.36,7.9c-2.84,5.15-3.08,11.84-.73,19.9a1,1,0,0,1-.68,1.24A.9.9,0,0,1,401.26,129.81Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.66,120.85a1,1,0,0,1-1-1c-.61-21.27,12-29.45,12.56-29.79a1,1,0,1,1,1.06,1.69h0c-.12.08-12.2,8-11.62,28a1,1,0,0,1-1,1Z",
    fill: "#fff"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M484.51,232a49.79,49.79,0,0,1-3.91-5.13l-25.34,0s-10.67,0-20-11.39c0,0,15.64,5,28.32,4.18a261.2,261.2,0,0,1,27.17.08S483.76,226.17,484.51,232Z",
    fill: "#f7a48b"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 659.26,
    y: 52.8,
    width: 147,
    height: 103,
    rx: 11.57,
    fill: "#e6e7e8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M806.26,64.37V69.8h-147V64.37A11.57,11.57,0,0,1,670.83,52.8H794.69A11.57,11.57,0,0,1,806.26,64.37Z",
    fill: "#ccebd4",
    opacity: 0.28
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.26,
    cy: 61.8,
    r: 5,
    fill: "#e6e7e8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 774.26,
    cy: 61.8,
    r: 5,
    fill: "#e6e7e8"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 792.26,
    cy: 61.8,
    r: 5,
    fill: "#e6e7e8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 683.26,
    y: 117.8,
    width: 9,
    height: 27,
    fill: "#344854"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 705.26,
    y: 98.8,
    width: 9,
    height: 46,
    fill: "#ccebd4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 730.26,
    y: 105.8,
    width: 9,
    height: 39,
    fill: "#344854"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 753.26,
    y: 90.8,
    width: 9,
    height: 54,
    fill: "#ccebd4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 777.26,
    y: 79.8,
    width: 9,
    height: 65,
    fill: "#344854"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M502.26,114.8a36.39,36.39,0,0,1,7.5-3.44,28.48,28.48,0,0,1,8.16-1.49,17.92,17.92,0,0,1,8.19,1.67A17.34,17.34,0,0,1,532.5,117l-.06-.07a18.22,18.22,0,0,1,3.67,6.81,23.73,23.73,0,0,1,.95,7.63l-.13,1.92c-.06.64-.2,1.27-.3,1.9a29.9,29.9,0,0,1-.89,3.74c-.36,1.23-.86,2.4-1.3,3.6L532.79,146l-.63-1.26a35.52,35.52,0,0,1,8.39,2.66,31.1,31.1,0,0,1,7.46,4.71,28.42,28.42,0,0,1,3.09,3.21,24.38,24.38,0,0,1,2.43,3.76,24,24,0,0,1,2.46,8.55c.08.74.08,1.49.13,2.23s0,1.47,0,2.21a12.57,12.57,0,0,1-.4,2.29,19.44,19.44,0,0,1-.62,2.14,24.87,24.87,0,0,1-4.3,7.77,25.45,25.45,0,0,1-15,8.94,26.27,26.27,0,0,1-4.42.44c-1.46,0-2.87,0-4.31,0l-8.58-.07-17.18-.19-8.58-.1c-1.41,0-2.92-.07-4.25-.05a2.37,2.37,0,0,0-1.58.83,2.43,2.43,0,0,0-.45.8c-.09.28-.13.65-.2,1a50.26,50.26,0,0,1-2.1,8.37,19.38,19.38,0,0,1-1.88,3.89,6.45,6.45,0,0,1-3.19,2.78,6.46,6.46,0,0,0,3-2.89,21.14,21.14,0,0,0,1.68-3.91,49.32,49.32,0,0,0,1.78-8.34,7.18,7.18,0,0,1,.19-1.11,3.16,3.16,0,0,1,.55-1.08,3.21,3.21,0,0,1,2.08-1.19c1.53-.08,2.89-.07,4.35-.1l8.58-.1,17.18-.18L527,192c1.43,0,2.88,0,4.28,0a24.6,24.6,0,0,0,4.11-.44,23.65,23.65,0,0,0,13.85-8.39,23.24,23.24,0,0,0,3.91-7.2,17.14,17.14,0,0,0,.56-2,10.79,10.79,0,0,0,.33-1.94l0-2.08c0-.68,0-1.38-.11-2.06a21.92,21.92,0,0,0-2.2-7.87,21.29,21.29,0,0,0-2.2-3.46,24.89,24.89,0,0,0-2.83-3,29,29,0,0,0-7-4.48,34.08,34.08,0,0,0-7.91-2.59l-1.14-.21.51-1,1.61-3.3c.42-1.15.93-2.27,1.3-3.43a30.5,30.5,0,0,0,.92-3.53c.1-.59.26-1.19.32-1.79l.17-1.81a22.33,22.33,0,0,0-.74-7.19,16.86,16.86,0,0,0-3.23-6.37l-.05-.06h0a16.56,16.56,0,0,0-5.87-5.29,17,17,0,0,0-7.76-1.86,28.25,28.25,0,0,0-8,1.17A38.31,38.31,0,0,0,502.26,114.8Z",
    fill: "#f29681"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M430.26,207.8a39,39,0,0,1-.61-6.57,45.83,45.83,0,0,1,.35-6.62A32.91,32.91,0,0,1,434.2,182a25.43,25.43,0,0,1,4.21-5.32,26.48,26.48,0,0,1,5.51-4A34.12,34.12,0,0,1,456.87,169c2.23-.2,4.49-.2,6.67-.19l6.58,0c4.39.06,8.77.08,13.16.17q13.17.19,26.33.78-13.17.58-26.33.78c-4.39.09-8.77.11-13.16.17l-6.58,0c-2.21,0-4.35,0-6.49.22a32.91,32.91,0,0,0-12.25,3.31,25.53,25.53,0,0,0-5.2,3.6,26.05,26.05,0,0,0-4.07,4.87,33.27,33.27,0,0,0-4.57,12A49,49,0,0,0,430.26,207.8Z",
    fill: "#f29681"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M410.26,145.8a27.81,27.81,0,0,1,12.34.22,29.17,29.17,0,0,1,11.31,5.4A31.49,31.49,0,0,1,442,161a38.13,38.13,0,0,1,4.16,11.63,62.49,62.49,0,0,0-5.5-10.82,37.18,37.18,0,0,0-3.63-4.74,31.22,31.22,0,0,0-4.32-4.05,28.38,28.38,0,0,0-5-3.21,34.78,34.78,0,0,0-5.5-2.27A38.18,38.18,0,0,0,410.26,145.8Z",
    fill: "#f29681"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M473.26,112.8A43.25,43.25,0,0,0,476,125.49a20,20,0,0,0,19.3,13.6,55.52,55.52,0,0,0,13-1.29,37.39,37.39,0,0,1-13,2.85l-1.69,0-1.7-.14a13.75,13.75,0,0,1-1.69-.24,16.16,16.16,0,0,1-1.68-.35,19.13,19.13,0,0,1-6.26-2.87,19.55,19.55,0,0,1-4.8-4.93,24.35,24.35,0,0,1-2.94-6.13A31.58,31.58,0,0,1,473.26,112.8Z",
    fill: "#f29681"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M435.26,101.8a20.13,20.13,0,0,1,5.81,6.74,18.6,18.6,0,0,1,2.29,8.8,18,18,0,0,1-2.34,8.79,22.6,22.6,0,0,1-5.76,6.78,40.32,40.32,0,0,0,4.36-7.46c.3-.64.49-1.32.75-2s.42-1.34.54-2a16.9,16.9,0,0,0,.45-4.12,21,21,0,0,0-1.7-8.13A32.41,32.41,0,0,0,435.26,101.8Z",
    fill: "#f29681"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M628.26,25.8l-197.87,278h77.87L679.88,26.55a17.49,17.49,0,0,0-8.24-1.25Z",
    fill: "#fff",
    opacity: 0.18
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M548.16,25.21l0,.09L378.21,303.8H298.88a27.63,27.63,0,0,1-27.62-27.62V257.23l164-231.93Z",
    fill: "#fff",
    opacity: 0.18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "671.41 77.37 671.41 146.8 794.04 146.8 794.04 143.98 674.26 143.98 674.26 77.37 671.41 77.37",
    fill: "#ccebd4"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 169.26,
    y: 88.8,
    width: 147,
    height: 191,
    rx: 14.37,
    fill: "#e6e7e8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.26,103.17v2.63h-147v-2.63A14.38,14.38,0,0,1,183.63,88.8H301.89A14.38,14.38,0,0,1,316.26,103.17Z",
    fill: "#ccebd4",
    opacity: 0.28
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.26,
    cy: 96.8,
    r: 4,
    fill: "#e6e7e8"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.26,
    cy: 96.8,
    r: 4,
    fill: "#e6e7e8"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.26,
    cy: 96.8,
    r: 4,
    fill: "#e6e7e8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 179.26,
    y: 117.8,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#ccebd4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 178.26,
    y: 175.8,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#ccebd4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 179.26,
    y: 223.8,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#ccebd4"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 179.26,
    y: 256.8,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#ccebd4"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 196.26,
    y: 134.8,
    width: 108,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 196.26,
    y: 193.8,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 196.26,
    y: 208.8,
    width: 37,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 196.26,
    y: 241.8,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 242.26,
    y: 208.8,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 196.26,
    y: 150.8,
    width: 61,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 220.26,
    y: 166.8,
    width: 76,
    height: 6,
    rx: 3,
    fill: "#ccebd4",
    opacity: 0.28
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 634.27,
    y: 518.71,
    width: 8.16,
    height: 69.32,
    fill: "#bcbec0"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 627.48,
    y: 578.52,
    width: 21.75,
    height: 44.86,
    fill: "#a7a9ac"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M674.91,514.94H586.85v-2.86h87.84a43.57,43.57,0,0,0,16.65-7.27c10.75-7.81,15.65-19.48,14.57-34.7V470l.48-29.37,2.86,0L708.76,470c1.43,20.28-7.82,31.43-15.84,37.22a45.45,45.45,0,0,1-17.9,7.73Z",
    fill: "#ccebd4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M520.09,634.25c-5.43,5.44-24.48,10.88-24.48,10.88-33.94,10.53-55.75,2.93-61.18.61a7.2,7.2,0,0,1-2.8-2,3.35,3.35,0,0,1-.73-1.47c-.54-3.05,6.28-3.9,6.28-3.9l19-5.44c13.59-2.72,16.31-9.51,16.31-9.51,2.72-8.16,7.37-6,7.37-6L514.66,622A18.85,18.85,0,0,1,520.09,634.25Z",
    fill: "#ccebd4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M556.8,585.32,569,603l12.23,4.08s11.88-16.5,12.74-16.41.85-9.42.85-9.42l-15-13.59Z",
    fill: "#f9b499"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M484.75,600.27l-4.86,17.11s8.94,2.41,4.86,10.32c0,0,23.11,5.19,29.91-5.68V609.58Z",
    fill: "#f9b499"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M700.45,318.67a6.55,6.55,0,0,0-5.23,6.65L696.86,413l2.55,52.76s15.36,9.09,15.21-9.07c0,0,3.93-113.3-7-132.33C707.67,324.34,705.68,317.76,700.45,318.67Z",
    fill: "#ccebd4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M700.45,318.67a6.55,6.55,0,0,0-5.23,6.65L696.86,413l2.55,52.76s15.36,9.09,15.21-9.07c0,0,3.93-113.3-7-132.33C707.67,324.34,705.68,317.76,700.45,318.67Z",
    fill: "#fff",
    opacity: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M640.77,300.9c-.3-12.56-2.42-16-2.42-16l10.18-10.28a18.71,18.71,0,0,0,4.77,1.6c2.72.52,8.16.52,13.6,12.75C671.6,299.58,640.77,300.9,640.77,300.9Z",
    fill: "#f9b499"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M640.77,300.9s17.94-14.79,7.76-26.26a18.71,18.71,0,0,0,4.77,1.6c2.72.52,8.16.52,13.6,12.75C671.6,299.58,640.77,300.9,640.77,300.9Z",
    fill: "#f7a48b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634.95,
    cy: 257.05,
    rx: 18.35,
    ry: 33.3,
    fill: "#f9b499"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M681.58,278.27a22.25,22.25,0,0,1-4.54,1.79,4.57,4.57,0,0,0-3.14,3.46c-.42,1.72-2.14,3.68-7.72,3.83,0,0-6.08-11.61-12.88-11.11,0,0-8.15-.84-8.83-7.63s-5.75-5-5.75-5-5.51,3.61-2.94-10c0,0-10.19-11.51-12.65-22.07A39.37,39.37,0,0,0,618,244.33s-10.9-21,10.85-26.93c0,0,10.52-18.58,25.65,0,0,0,20.56-10,20.56,15.86,0,0,19,9.52,9.52,28.55C684.57,261.81,692.34,272.51,681.58,278.27Z",
    fill: "#344854"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M681.58,278.27a22.25,22.25,0,0,1-4.54,1.79,4.57,4.57,0,0,0-3.14,3.46c-.42,1.72-2.14,3.68-7.72,3.83,0,0-6.08-11.61-12.88-11.11,0,0-8.15-.84-8.83-7.63s-5.75-5-5.75-5-5.51,3.61-2.94-10c0,0,12.09-24.46,21.6-6.79,0,0,2.72,2.72,2.72,17.67C660.1,264.53,660.92,279.78,681.58,278.27Z",
    opacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 644.47,
    cy: 261.13,
    rx: 6.12,
    ry: 7.48,
    fill: "#f9b499"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M619.32,395s-25.82,13.59-51.65,8.15c0,0-6.8,10-19,11.11l-22-2.19v-7.56s7.72-6.15,39.33-11.22a113.31,113.31,0,0,0,28.89-11.8s1.87-1.25,4.55-3c5.35-3.44,14-8.74,17.43-9.53l-.23,23.3Z",
    fill: "#f9b499"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M619.32,395s-25.82,13.59-51.65,8.15c0,0,21.65-10.3,31.73-24.64,5.35-3.44,14-8.74,17.43-9.53l-.23,23.3Z",
    fill: "#f7a48b"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 253.68,
    y: 420.84,
    width: 9.51,
    height: 232.44,
    fill: "#bcbec0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M352.9,443s3.29,40.12-85.63,34.95c0,0-5.18-19,1.51-36,0,0,38.81-39.84,76.66-9.13Z",
    fill: "#344854"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M352.9,443s3.29,40.12-85.63,34.95c0,0-5.18-19,1.51-36,0,0,38.81-39.84,76.66-9.13Z",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M220.75,394.13l16.62,71.57H247.7l-13.34-74.43a7.08,7.08,0,0,0-7.13-5.92h-.18A7.11,7.11,0,0,0,220.75,394.13Z",
    fill: "#bcbec0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M359.7,387.93l5.4,3.64a8,8,0,0,1,3.53,7.16l-4.16,67H354.26L357.14,410Z",
    fill: "#bcbec0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 348.83,
    y: 365.11,
    width: 10.87,
    height: 44.86,
    fill: "#f9b499"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M362.57,317.83c-1,4-4.34,6.32-6.07,7.31a11.45,11.45,0,0,1-1.07.54,130.56,130.56,0,0,0-11.79-34.82h0a67.87,67.87,0,0,0-3.89-6.74c-9.09-12.33-24.9-16.22-24.9-16.22l-.2-5.65,0-.69c12.86-5.55,15.88-22.18,16.44-26.32.08-.61.11-.95.11-.95l3.2,1.8,0,.75.37,20.37c-3.2,12.41,11.36,17.49,11.36,17.49,10.87,5.43,6.8,23.11,6.8,23.11C351.54,311.38,362.57,317.83,362.57,317.83Z",
    fill: "#344854"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M362.57,317.83c-1,4-4.34,6.32-6.07,7.31l-.54.1a113,113,0,0,0-12.32-34.38h0a53.57,53.57,0,0,0-3.89-6c-9.09-12.32-24.9-16.21-24.9-16.21l-.23-6.35,0,0c12.86-5.56,15.86-22.79,16.41-27,.08-.61.11-.95.11-.95l3.2,2.52,0,0,.37,20.37c-3.2,12.41,11.36,17.49,11.36,17.49,10.87,5.43,6.8,23.11,6.8,23.11C351.54,311.38,362.57,317.83,362.57,317.83Z",
    opacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M364.7,365.56l-11.8,6.35-114.18-2.72c-16.79-2-23.54-11.14-26-16a4.52,4.52,0,0,1,.59-4.91c2.15-2.57,6.1-8.24,11.15-19.75l.64-1.49s24.47-66.6,68-65.92l21.63,6.71s27.14,5,35.46,36.11a250.17,250.17,0,0,1,9.51,42.13s.85,7.68,5.94,12.9A4.15,4.15,0,0,1,364.7,365.56Z",
    fill: "#ccebd4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M331.16,231.91a42.4,42.4,0,0,1-2,13.06c-2.72,8.53-8.06,15-14.55,17.29a15.3,15.3,0,0,1-5.2.91c-6.5,0-12.33-4.09-16.31-10.59a39.76,39.76,0,0,1-5.44-20.67,46.66,46.66,0,0,1,.3-5.22c1.74-14.79,10.67-26.05,21.45-26.05C321.42,200.64,331.16,214.64,331.16,231.91Z",
    fill: "#f9b499"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M291.06,270.07l-1.43,1.2a12.7,12.7,0,0,0-4.27,7l-1.78,8-12.09,8.46a3.27,3.27,0,0,0-1.39,2.88l1.25,19.92-17.67,19c-19,0-29.19-8-29.19-8l.64-1.49s24.47-66.6,68-65.92C290.38,264.53,291.06,270.07,291.06,270.07Z",
    opacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M304.88,316.52h-33.6l-1.18-18.9a3.27,3.27,0,0,1,1.39-2.88l12.09-8.46,2.58,3.67Z",
    fill: "#ccebd4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M304.88,316.52h-33.6l-1.18-18.9a3.27,3.27,0,0,1,1.39-2.88l12.09-8.46,2.58,3.67Z",
    fill: "#fff",
    opacity: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M275.72,307.14l8.45,9.38H271.28l-1.18-18.9a3.27,3.27,0,0,1,1.39-2.88l12.09-8.46,2.58,3.67-9.72,7.89a6.45,6.45,0,0,0-2.37,5h0A6.39,6.39,0,0,0,275.72,307.14Z",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M314.38,267.49s10,14,.46,49h28.24s1-26.84-6.57-36.18C336.51,280.34,329.33,271.56,314.38,267.49Z",
    fill: "#ccebd4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M314.38,267.49s10,14,.46,49h28.24s1-26.84-6.57-36.18C336.51,280.34,329.33,271.56,314.38,267.49Z",
    fill: "#fff",
    opacity: 0.3
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 238.72,
    y: 403.17,
    width: 110.1,
    height: 6.8,
    fill: "#bcbec0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M226.43,365.9,224.49,410h14.23V369.19S230.44,368,226.43,365.9Z",
    fill: "#f9b499"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M226.43,365.9,226,376.08l8.67-.77v-6.84A25,25,0,0,1,226.43,365.9Z",
    fill: "#f7a48b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M234.65,400.37s-15,10.77,4.07,8.14v-5.34S234.65,404.37,234.65,400.37Z",
    fill: "#f7a48b"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M331.16,231.91a42.4,42.4,0,0,1-2,13.06c-6-2-12.26-34.94-12.26-34.94-3.39-8.29-13,8.55-13,8.55-6.19,13.61-14.25,9.19-15.89,8.11,1.74-14.79,10.67-26.05,21.45-26.05C321.42,200.64,331.16,214.64,331.16,231.91Z",
    fill: "#f7a48b"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M267.27,477.93s-34-34-16.31-53h103.3s1.36,11.66-1.36,18.06c0,0-40.77-30.29-69.32-7.18C283.58,435.8,268.63,445.31,267.27,477.93Z",
    fill: "#344854"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M237.37,465.7H367.52a8.49,8.49,0,0,1,8.49,8.49v5.1a0,0,0,0,1,0,0H237.37a0,0,0,0,1,0,0V465.7A0,0,0,0,1,237.37,465.7Z",
    fill: "#939598"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 294.45,
    y: 473.86,
    width: 14.95,
    height: 126.41,
    fill: "#bcbec0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.38 594.83 313.23 595.07 313.23 609.98 385.79 648.07 385.79 652.73 365.74 652.73 365.74 648.07 313.23 625.92 306.69 625.92 306.69 652.73 313.23 652.73 313.23 655.87 289.44 655.87 289.44 652.25 295.81 652.25 295.81 624.79 290.86 624.79 238.19 648.07 238.19 651.77 216.98 651.77 216.98 648.07 290.38 609.78 290.38 594.83",
    fill: "#939598"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 426.3,
    y: 404.53,
    width: 107.38,
    height: 5.44,
    fill: "#bcbec0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.84 320.26 422.23 407.25 477.28 407.25 456.6 320.26 401.84 320.26",
    fill: "#d1d3d4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.84 320.26 466.5 407.25 477.28 407.25 472.59 387.54 428.93 320.26 401.84 320.26",
    fill: "#fff",
    opacity: 0.3
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "456.6 320.26 460.6 320.26 480.68 404.53 476.63 404.53 456.6 320.26",
    fill: "#bcbec0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M675.05,499.68H543.2l-1.36,12.24c7.85,13.45,34.18,39.84,43.17,48.69a4.1,4.1,0,0,1-.06,5.95,277.37,277.37,0,0,1-25.44,20.12c-13.59,6.79-24.46-9.52-24.46-9.52l-5.44,38.06c-40.78-4.08-47.57-15-47.57-15L497,501c-3.46-9.35-5-15.68-5.58-19.94-1-7.5,1-8.6,1-8.6,22.63-27.19,102.43-55.73,102.43-55.73l48.94,5.43,38.06,1.36,14.95,32.63C698.16,499.68,675.05,499.68,675.05,499.68Z",
    fill: "#344854"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M505.63,611.33s25.46-106,37-106.09l-.74,6.68-6.79,65.24-5.44,38.06S512.92,612.87,505.63,611.33Z",
    opacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M675.05,499.68H550.42c37.57-2.24,54.36-8.17,61.85-13.06a9.93,9.93,0,0,0,2.79-13.85c-8.86-13.14-26.29-13.78-35.15-13.16a28.41,28.41,0,0,0-8.48,1.93c-10.45,4.16-16.82,4.16-16.82,4.16-13.07-1.36-23.72,6.8-23.72,6.8-17.75,14.95-39.46,8.61-39.46,8.61h0c-1-7.5,1-8.6,1-8.6,22.63-27.19,102.43-55.73,102.43-55.73l48.94,5.43,38.06,1.36,14.95,32.63C698.16,499.68,675.05,499.68,675.05,499.68Z",
    opacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M699.41,465.74a3.38,3.38,0,0,1-3.89,3.45c-6.51-.95-14.65-2.18-19.35-2.9a3.93,3.93,0,0,1-3.29-4.42c1.34-9.65,3.21-23.48,3.31-24.33l0,0-14.93,18.35a5.66,5.66,0,0,1-5.09,2c-51-5.89-61.34-41.13-61.34-41.13C616.6,405.89,619.32,395,619.32,395l-2.72-2.72.3-29.9c1.67-29.91,11.94-40.78,11.94-40.78v-8a3.71,3.71,0,0,1,1-2.57c21.14-22,34.31-22,34.31-22,13.59-1.35,12.23,13.6,12.23,13.6,4.87,7.8,8.74,21.43,11.8,37.68h0C696.62,384.91,699,449.14,699.41,465.74Z",
    fill: "#ccebd4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M647.87,411.33c-4.08,13.59-13.6,17.67-13.6,17.67-25.82,16.31-81.55,25.83-81.55,25.83-12.24,13.59-34,12.23-34,12.23a40.17,40.17,0,0,0-8.16,4.08c-9.52,0-4.06-11.24-4.06-11.24a15.25,15.25,0,0,1,2.93-2.65c11.31-8.06,39.19-11.94,39.19-11.94,9.51-8.15,36.7-23.11,36.7-23.11,20.17-9.65,28.45-18.16,31.79-23a13.76,13.76,0,0,0,2.19-4.2C628.84,403.17,647.87,411.33,647.87,411.33Z",
    fill: "#f9b499"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M647.87,411.33c-4.08,13.59-13.6,17.67-13.6,17.67-25.82,16.31-81.55,25.83-81.55,25.83-12.24,13.59-34,12.23-34,12.23a40.17,40.17,0,0,0-8.16,4.08c-9.52,0-4.06-11.24-4.06-11.24a15.25,15.25,0,0,1,2.93-2.65s24.24,7.09,44.63-10.58c0,0,13.59,1.36,36.7-9.51l37.3-16.7s8.76-5,0-13.21l-11-8a13.76,13.76,0,0,0,2.19-4.2C628.84,403.17,647.87,411.33,647.87,411.33Z",
    fill: "#f7a48b"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M660.1,332.49s12.65,17.67,5.65,62.53L664,407.25s-1.16,6.8-16.11,4.08c0,0-2.72,12.23-13.6,17.67,0,0-8.12,5.12-23.09,10.72,0,0,9.54,9.52,26.51,14.35,0,0,11.37-21.61,19.19-32a21.51,21.51,0,0,1,7.48-6.14c2.47-1.27,6.21-4.32,7.44-11.39C671.8,404.53,680.49,347.44,660.1,332.49Z",
    opacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M676.41,302.59c-20.39-14.95-47.57,19-47.57,19v-8a3.71,3.71,0,0,1,1-2.57c21.14-22,34.31-22,34.31-22C677.77,287.64,676.41,302.59,676.41,302.59Z",
    fill: "#fff",
    opacity: 0.3
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M699.41,465.74a3.38,3.38,0,0,1-3.89,3.45c-6.51-.95-14.65-2.18-19.35-2.9a3.93,3.93,0,0,1-3.29-4.42c1.34-9.65,3.21-23.48,3.31-24.33l0,0s1.56-5.78,5.64-8.5c0,0-4.08,34,5.44,27.19,0,0,10.87-10.88,2.71-65.25l-1.79-50.66C696.62,384.91,699,449.14,699.41,465.74Z",
    opacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M602.59,585.48a94.88,94.88,0,0,1-47.15,65.08,3.23,3.23,0,0,1-1.88-.13c-1.06-.51-1.77-2.08.52-6.66,0,0,16.31-27.19,12.23-34,0,0-6.43-5.35.87-9.47,0,0,5.93-4.68,8.65,2.39l11.92-10.61a10.72,10.72,0,0,0,3.58-7.36,26.79,26.79,0,0,0,.07-2.85,3.69,3.69,0,0,1,4.58-3.69,14.12,14.12,0,0,1,4.38,1.92h0A5.34,5.34,0,0,1,602.59,585.48Z",
    fill: "#ccebd4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M616.44,600.76l-9.66,11.66a3.35,3.35,0,0,1-3.54,1c-1.75-.52-4.42-.49-6.78,2.82a12,12,0,0,0-1.84,4.58c-.87,4.53-4.86,17.74-22.68,29.81,0,0-12.1,9.17-18.38-.21a3.23,3.23,0,0,0,1.88.13,94.88,94.88,0,0,0,47.15-65.08,5.34,5.34,0,0,0-2.22-5.37c.33,0,4.33.22,12.16,10.64l4.1,6.16A3.24,3.24,0,0,1,616.44,600.76Z",
    fill: "#344854"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M517.38,658.72H494.27C492.91,649.2,482,656,482,656c-23.11,8.15-48-1.35-48-1.35-7.18-1.34-3.17-12.42-3.17-12.42a3.35,3.35,0,0,0,.73,1.47,7.2,7.2,0,0,0,2.8,2c5.43,2.32,27.24,9.92,61.18-.61,0,0,19-5.44,24.48-10.88C522.81,643.77,517.38,658.72,517.38,658.72Z",
    fill: "#344854"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M565,642.41s38.06-23.82,73.4-22.78c0,0,44.86,2.39,73.4,21.42l-4.08,4.08s-34-19-69.32-18.32c0,0-35.74-1.49-70.2,20Z",
    fill: "#bcbec0"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 634.27,
    y: 623.38,
    width: 8.16,
    height: 23.11,
    fill: "#bcbec0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.47,
    cy: 649.2,
    r: 9.51,
    fill: "#a7a9ac"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.59,
    cy: 649.2,
    r: 9.51,
    fill: "#a7a9ac"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 638.35,
    cy: 649.2,
    r: 9.51,
    fill: "#a7a9ac"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 499.71,
    y: 420.84,
    width: 9.51,
    height: 232.44,
    fill: "#bcbec0"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 419.51,
    y: 420.84,
    width: 9.51,
    height: 232.44,
    fill: "#bcbec0"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 197.95,
    y: 420.84,
    width: 9.51,
    height: 232.44,
    fill: "#bcbec0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.66,
    cy: 233.26,
    rx: 5.44,
    ry: 6.8,
    fill: "#f9b499"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M346.11,275.4c-28.87,2.31-13.32-15.78-8-21.27a10.22,10.22,0,0,0,2.91-6.06c.65-7.17-7-10.24-9.27-11a4.57,4.57,0,0,1-1.27-.63c-8.6-6.25-3.38-22.68-3.38-22.68-5.19-9.93-12.28-12.15-12.28-12.15-3.07-.78-6.15,1.45-8.59,4.13a27.21,27.21,0,0,0-5.83,10.79c-3.61,12.22-12.76,9.93-12.76,9.93-.68,17,5.44,26.11,5.44,26.11v8.55c-19,7.48-12.24,19.71-12.24,19.71,4.08,8.15-1.36,10.87-1.36,10.87l-7.17,4.52a7.38,7.38,0,0,0-3.58,5.83c-.3,6.49,8,8.68,8,8.68C267.27,325.7,251,308,251,308c2.72,13.6-9.52,16.32-9.52,16.32-6.79,0-5.8-8.16-5.8-8.16,13.22-9.51,3.08-21.73,3.08-21.73-10.87-12.24-4.07-20.83-4.07-20.83,4.07-7.23,12.72-6.06,12.72-6.06,16.79-1,11.43-21.86,11.43-21.86-8.48-27,9.83-32.82,9.83-32.82A23.26,23.26,0,0,0,279.5,202a22.79,22.79,0,0,1,24.35-13c17.55-4.83,23.23,7.54,23.23,7.54C342,204.72,338,217,338,217c-5.44,13.6,2.72,19,2.72,19,12.23,10.88,2.42,25.15,2.42,25.15C336,270,346.11,275.4,346.11,275.4Z",
    fill: "#344854"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M327.08,196.56h-9.52A46.05,46.05,0,0,0,303.85,189C321.4,184.19,327.08,196.56,327.08,196.56Z",
    opacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M293.1,252.58v8.55c-19,7.48-12.24,19.71-12.24,19.71,4.08,8.15-1.36,10.87-1.36,10.87l-7.17,4.52a7.38,7.38,0,0,0-3.58,5.83c-.3,6.49,8,8.68,8,8.68-19,1.36-12.23-14.95-12.23-14.95,1.77-6.2.1-10.57-1.29-12.87a10.67,10.67,0,0,1-1.6-7.42c.88-4.88,4.88-6.34,7.57-6.74a11.17,11.17,0,0,0,8.25-5.47c3.41-6.24.65-14.15.65-14.15-5.45-18.12,5.75-20.76,5.75-20.76,1.66-.8,3.78-1.91,3.78-1.91C286.3,244.14,293.1,252.58,293.1,252.58Z",
    opacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8,277.22c-.87,5.85-7.39,6.83-7.39,6.83-12.24.47-17.67-11.37-17.67-11.37-2.72-8.15,1.36-11.55,1.36-11.55v-8.55a26,26,0,0,0,4.24,5.33h0a4.49,4.49,0,0,0,.39.36c.19.17.37.35.56.51a17.1,17.1,0,0,0,11.12,4.38,15.64,15.64,0,0,0,5-.83,1.33,1.33,0,0,1,.21-.08l.23,6.35C316.68,272.26,317.13,275.08,316.8,277.22Z",
    fill: "#f9b499"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8,277.22a25,25,0,0,1-19.46-19.3h0a4.51,4.51,0,0,0,.39.37,6.47,6.47,0,0,0,.56.51c7.27,6.49,14.75,4.08,16.11,3.55a1.33,1.33,0,0,1,.21-.08l.23,6.35C316.68,272.26,317.13,275.08,316.8,277.22Z",
    fill: "#f7a48b"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 238.72,
    y: 316.18,
    width: 114.18,
    height: 86.99,
    fill: "#d1d3d4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "247.7 316.18 306.86 403.17 344.53 403.17 275.66 316.18 247.7 316.18",
    fill: "#fff",
    opacity: 0.3
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "295.81 316.52 352.9 394.14 352.9 380.3 304.88 316.52 295.81 316.52",
    fill: "#fff",
    opacity: 0.3
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M236.71,316.18h2a0,0,0,0,1,0,0v87a0,0,0,0,1,0,0h-2a2.06,2.06,0,0,1-2.06-2.06V318.24A2.06,2.06,0,0,1,236.71,316.18Z",
    fill: "#bcbec0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M339.31,486.09,287.66,597.55s-5.57,25.61-10.66,36.52a7,7,0,0,1-4.78,3.91c-4.6,1.07-12.68,1.4-14.57-8.72a19.55,19.55,0,0,1,.93-10.4,21.26,21.26,0,0,1,3.28-5.81c4.12-5.21,10-13.5,10.85-19.58l4.92-21v0l13.59-57.93,24.44-63.1S331.16,429,346.11,444c0,0,1.76.89,2.72,4.32v0C350.24,453.43,349.86,464.19,339.31,486.09Z",
    fill: "#f9b499"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M348.83,448.27v0c-13.6-5.16-20.39,13.32-20.39,13.32l-50.8,110.84,13.59-57.93,24.44-63.1S331.16,429,346.11,444C346.11,444,347.87,444.84,348.83,448.27Z",
    fill: "#f7a48b"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M299.89,497,251,596.19c0,12.23-6.8,28.55-6.8,28.55-2.72,2.71-10.25,6.79-10.25,6.79-4.8,2.72-6.06,0-6.06,0L222.41,622c-.73-1-.68-2.63-.08-4.68h0c2.7-9.26,16.37-26.58,16.37-26.58l25.83-100.58C274.07,424.92,304,435.8,304,435.8,332.51,444,299.89,497,299.89,497Z",
    fill: "#f9b499"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M277,634.07c-1.14,9.33-11.09,19.21-11.09,19.21-6.8,5.44-10.87-6.8-10.87-6.8-6.8-17.67,3.54-27.62,3.54-27.62a19.55,19.55,0,0,0-.93,10.4c1.89,10.12,10,9.79,14.57,8.72A7,7,0,0,0,277,634.07Z",
    fill: "#ccebd4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M244.16,624.74c0,6.79-10.87,20.39-10.87,20.39-6.8,8.15-11.42-3.21-11.42-3.21-8.47-17.7,0-24.27.46-24.58-.6,2-.65,3.7.08,4.68l5.44,9.51s1.26,2.72,6.06,0C233.91,631.53,241.44,627.45,244.16,624.74Z",
    fill: "#ccebd4"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 409.97,
    width: 354.77,
    height: 16.31,
    fill: "#939598"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.45,
    cy: 359.68,
    r: 8.16,
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M618,244.33s-6-11.72,5.14-12.75C623.13,231.58,619.32,236,618,244.33Z",
    opacity: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 575.83,
    y: 499.68,
    width: 112.82,
    height: 23.11,
    rx: 4.93,
    fill: "#ccebd4"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 575.83,
    y: 499.68,
    width: 112.82,
    height: 23.11,
    rx: 4.93,
    fill: "#fff",
    opacity: 0.4
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M716.47,569.59a324.33,324.33,0,0,1,.52-34.44A439,439,0,0,1,727.79,465c3-13,6.72-25.76,10.58-38.53.12-.38.73-.26.61.14-11.94,45-21.74,91.37-21.06,138.11.19,13.08,1.72,25.93,2.93,38.93,0,.35-.54.49-.61.13A194,194,0,0,1,716.47,569.59Z",
    fill: "#ccebd4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M739,426.57s18.1,45.91,14,56.71-12.41,13.1-12.41,13.1S751.72,512.18,744,527,719,541.12,717.92,557.93C717.85,557.93,716.89,487.65,739,426.57Z",
    fill: "#ccebd4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M719.81,528.91a.36.36,0,0,1,0-.25,421.32,421.32,0,0,1,17.6-92.41c0-.09.18,0,.15,0q-5.41,20.21-9.53,40.59a19.84,19.84,0,0,1,8.64-4.81s.08.07,0,.08a23.07,23.07,0,0,0-8.92,6c-.53,2.67-1,5.33-1.47,8,4.05-4.51,9.65-6.76,15.26-8.88m0,.11c-5.87,2.39-11.74,5.44-15.61,10.49q-2.1,11.42-3.64,22.93a21.84,21.84,0,0,1,10.84-6.18c.13,0,.21.17.07.19a22.76,22.76,0,0,0-10.94,7h0q-.54,4.05-1,8.11a27.72,27.72,0,0,1,7.5-4.52c.07,0,.12.09,0,.12a25.89,25.89,0,0,0-7.57,5h-.1c-.3,2.57-.6,5.15-.87,7.72a36.87,36.87,0,0,1,15.35-10.95c.11,0,.19.13.07.18A40,40,0,0,0,720.49,529a.32.32,0,0,1-.39.12q-.58,5.94-1,11.88c-.44,5.94-.11,0-.09,0,.21-4,.48-8.07.82-12.12Z",
    fill: "#344854"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M734.35,467.46a22.53,22.53,0,0,1,10.87-3.38c.09,0,.09.11,0,.13a43.2,43.2,0,0,0-10.74,3.52.15.15,0,0,1-.2-.07A.16.16,0,0,1,734.35,467.46Z",
    fill: "#344854"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M732.15,516.08a22.68,22.68,0,0,1,8.15-2.79.08.08,0,0,1,.08.07.08.08,0,0,1-.08.08,30.79,30.79,0,0,0-8.06,2.83C732.13,516.33,732.05,516.14,732.15,516.08Z",
    fill: "#344854"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M677.39,488.06A123.15,123.15,0,0,1,697,507.81a75.25,75.25,0,0,1,12.82,25.92,185.81,185.81,0,0,1,6.54,60.14A144.7,144.7,0,0,1,710.67,627a.32.32,0,0,1-.42.16.3.3,0,0,1-.19-.32,188.43,188.43,0,0,0,4-58.33c-1.76-19.17-5.12-40.13-16-56.34-5.95-8.81-13.64-16.07-21.22-23.48C676.42,488.28,677,487.72,677.39,488.06Z",
    fill: "#ccebd4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M714.68,580.13a112.81,112.81,0,0,0-13.79-20.54c-8.36-9.7-15.49-16.67-16.23-22.71s9.8-9.71,9.8-9.71-12.67,1.3-15.61-4.2-2.46-36-2.46-36,21.53,17.87,30.34,41.42S714.68,580.13,714.68,580.13Z",
    fill: "#ccebd4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M683.61,495.37c8.8,10.09,17.76,20.8,22.49,33.54a126.31,126.31,0,0,1,4.06,13.46h0c.22.91.45,1.83.66,2.75a.38.38,0,0,1,0,.15,257,257,0,0,1,4.4,28.53s-.09.08-.09,0c-.63-4.81-1.36-9.66-2.23-14.52h-.13a19.89,19.89,0,0,0-5.87-1.95c-.13,0-.1-.25,0-.24a22,22,0,0,1,5.87,1.47c-.78-4.4-1.66-8.8-2.7-13.08a63.36,63.36,0,0,0-13.35-2.76m0-.08a52.26,52.26,0,0,1,13.2,2.1c-.19-.73-.38-1.46-.55-2.21a70.42,70.42,0,0,0-8.81-2.19v-.09a44.36,44.36,0,0,1,8.7,1.71c-1-3.75-2-7.46-3.27-11.08a66.21,66.21,0,0,0-3.66-8.64,54.5,54.5,0,0,0-7.19-1.83v-.12a19.69,19.69,0,0,1,6.75,1.17c-1-2-2.16-4-3.38-5.87h0c-5-1.46-10.11-2.93-15.39-2.33a.08.08,0,0,1,0-.11.1.1,0,0,1,0,0c5.06-.94,9.92.18,14.79,1.47-.48-.77-1-1.47-1.47-2.26a34.27,34.27,0,0,0-9.42-2.19s-.07-.1,0-.1a24.71,24.71,0,0,1,8.81,1.47c-3.83-5.55-8.12-10.8-12.37-16-.21-.23-.06-.36.15-.11Z",
    fill: "#344854"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M682.35,516.08a20.81,20.81,0,0,1,4.53.17c.17,0,.14.33,0,.33-1.47-.08-2.94-.3-4.49-.33a.08.08,0,0,1-.11-.06A.09.09,0,0,1,682.35,516.08Z",
    fill: "#344854"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M696.55,546.72a21,21,0,0,1,6.89,1.92v.11c-2.27-.72-4.59-1.12-6.89-1.67a.19.19,0,0,1-.18-.18A.18.18,0,0,1,696.55,546.72Z",
    fill: "#344854"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M702.19,536.91a15.45,15.45,0,0,1,2.94.5c.1,0,0,.17,0,.17a15.35,15.35,0,0,1-2.94-.36.16.16,0,0,1-.1-.2A.13.13,0,0,1,702.19,536.91Z",
    fill: "#344854"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M772.89,510.36a104.13,104.13,0,0,0-20,12.23,63.51,63.51,0,0,0-15.69,18.6,156.66,156.66,0,0,0-17.47,47.88,121.73,121.73,0,0,0-2,28.26.27.27,0,0,0,.53,0,158.19,158.19,0,0,1,8.52-48.54c5.27-15.32,12.22-31.79,24.42-42.9,6.63-6,14.38-10.37,22-14.9A.35.35,0,1,0,772.89,510.36Z",
    fill: "#ccebd4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M723.9,578.1a95.1,95.1,0,0,1,15.42-14c8.8-6.23,16-10.5,17.84-15.3s-6.06-9.9-6.06-9.9,10.08,3.64,13.66-.23S774,509.71,774,509.71,752.8,520,740.79,537.42,723.9,578.1,723.9,578.1Z",
    fill: "#ccebd4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M724.51,573c8.8-21.93,21.4-42.3,40.22-56.89h0a100.7,100.7,0,0,0-13.48,13.2,23.43,23.43,0,0,1,12.13,1.19c.09,0,0,.15,0,.13a32.6,32.6,0,0,0-12.44-.72h-.13c-.65.75-1.28,1.47-1.91,2.3a38.47,38.47,0,0,1,6.44.14v.09a32.42,32.42,0,0,0-6.75.19,139,139,0,0,0-9.11,13,10.7,10.7,0,0,1,4.4-.17.09.09,0,0,1,0,.17,24.23,24.23,0,0,0-4.73.46c-.53.83-1,1.67-1.56,2.51a43.31,43.31,0,0,1,13.54-.18m0,.12a54.47,54.47,0,0,0-13.85.61c-.48.81-.92,1.65-1.39,2.45a29.47,29.47,0,0,1,8.07,0,.1.1,0,0,1,0,.12.1.1,0,0,1,0,.05,30.13,30.13,0,0,0-8.32.26c-2,3.53-3.92,7.13-5.74,10.75a7.63,7.63,0,0,1,3.52-.17v.1a15.59,15.59,0,0,0-3.77.59q-2.45,4.92-4.66,9.88c-.15.3-.66.15-.48-.14Z",
    fill: "#344854"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M739.78,553.93a16.87,16.87,0,0,1,6.49.07m0,.1a49.43,49.43,0,0,0-6.44,0,.12.12,0,0,1-.07-.15s0,0,0,0Z",
    fill: "#344854"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M756.24,526.55a11.49,11.49,0,0,1,2.93-.16.1.1,0,0,1,.06.13.09.09,0,0,1-.06.06c-1,0-1.94.15-2.93.22a.14.14,0,0,1-.09-.17A.24.24,0,0,1,756.24,526.55Z",
    fill: "#344854"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "694.84 664.59 744.96 664.59 737.81 605.03 735.98 589.76 703.82 589.76 701.99 605.03 694.84 664.59",
    fill: "#344854"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "701.99 605.03 737.81 605.03 735.98 589.76 703.82 589.76 701.99 605.03",
    fill: "#231f20",
    opacity: 0.3
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 699.22,
    y: 584.47,
    width: 41.37,
    height: 12.94,
    fill: "#344854"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.64e4a8989e97b3e6091310a3b56d58b1.svg";
export { ForwardRef as ReactComponent };